module.exports = __webpack_public_path__ + "static/media/application-retrofit.8f5ee9a0.png";